import React, { Component } from 'react'

import "../../Assets/CSS/AppDownload.css";
import play_store from "../../Assets/Img/play_store.jpg";
import app_store from "../../Assets/Img/app_store.jpg";
import axios from 'axios';
import { SiteInfoURL } from '../../APIServices/SiteInfoRequest';

export default class AppDownload extends Component {

  constructor() {
    super();
    this.state = {
      show: false,
      OS: null,
      link: "",
      android: "",
      ios: ""
    }

    this.getOS = this.getOS.bind(this);
    this.hideModal = this.hideModal.bind(this);
  }

  componentDidMount() {

    axios.get(SiteInfoURL()).then((res) => {
      let android = res.data[0]["android_app_link"];
      let ios = res.data[0]["ios_app_link"];
      let { show, OS } = this.getOS();

      this.setState({
        show,
        OS,
        link: OS === 'Android' ? android : (OS === 'iOS' ? ios : "")
      })

    });
  }

  getOS() {
    var userAgent = navigator.userAgent;
    let OS = null;
    let show = false;

    // Check for iOS
    if (/iPhone|iPad|iPod/i.test(userAgent)) {
      OS = "iOS";
      show = true;
    }


    // Check for Android
    if (/Android/i.test(userAgent)) {
      OS = "Android";
      show = true;
    }

    // Check WebView
    show = OS && !userAgent.includes('wv');

    // Unknown operating system
    return {
      OS, show
    }
  }

  hideModal() {
    this.setState({
      ...this.state,
      show: false
    })
  }



  render() {
    let { show } = this.state;
    return (
      <>
        {show ? (<div className='AppDownload px-3 pb-3' >
          <div className='main-div'>
            <div className='clearfix'>
              <button style={{ fontSize: 24 }} className='btn float-right' onClick={this.hideModal}>
                <i className="fa-solid fa-times-circle"></i>
              </button>
            </div>
            <div className='text-center'>
              <strong style={{ fontSize: 24 }}>Get Our {this.state.OS} App</strong>
              <br />
              <br />
              <a href={this.state.link}>
                <img width={200} src={this.state.OS === 'Android' ? play_store : ""} alt="" />
                <img width={200} src={this.state.OS === 'iOS' ? app_store : ""} alt="" />
              </a>
            </div>
            <div className="p-2 mt-4">
              <div className="d-flex justify-content-between">
                <button className="btn btn-danger float-left" onClick={this.hideModal} >Close</button>
                <a href={this.state.link} className="btn btn-success float-right" >Install</a>
              </div>
            </div>

          </div>
        </div>) : ""}
      </>

    )
  }
}
